export default "__VITE_ASSET__6c4b7e18__"